import React from 'react';
import cn from 'classnames';
import styles from './loading-indicator.module.scss';
export var LoadingIndicator = function (_a) {
    var size = _a.size, centered = _a.centered;
    return (React.createElement("div", { "data-testid": "loading-indicator", className: cn(styles.spinner, size && styles[size], centered && styles.centered) }));
};
